import { render } from "./ToggleFields.vue?vue&type=template&id=4a3e3470"
import script from "./ToggleFields.vue?vue&type=script&lang=ts"
export * from "./ToggleFields.vue?vue&type=script&lang=ts"
script.render = render

export default script